import { render, staticRenderFns } from "./CurvaSAcoesBtn.vue?vue&type=template&id=623694cb&scoped=true&"
import script from "./CurvaSAcoesBtn.vue?vue&type=script&lang=js&"
export * from "./CurvaSAcoesBtn.vue?vue&type=script&lang=js&"
import style0 from "./CurvaSAcoesBtn.vue?vue&type=style&index=0&id=623694cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623694cb",
  null
  
)

export default component.exports